import apiClient from '../../lib/apiClient';

export type GetConfigResponse = {
  adobeLaunchScriptSrc: string;
  oneTrustDomainScript: string;
};

const configQueryKey = ['config'];
const fetchConfig: () => Promise<GetConfigResponse> = async () => {
  const configResponse = await apiClient.fetch(location.href, `/api/getconfiguration`);

  return configResponse.json();
};

export const configQueryOptions = {
  queryKey: configQueryKey,
  queryFn: () => fetchConfig(),
  staleTime: Infinity,
};
